import { UPDATE_CATEGORY } from '../constants';
const initialState = {
  selected : 'sneakers',
}

const reducer = (state = initialState, action) => {
  switch(action.type) {
    case `${UPDATE_CATEGORY}`:{
      return { ...state, selected: action.selected}
    }
    default: return state;
  }
}

export default reducer;